import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2d117b', // Blue primary color
      light: '#F5F1FF',
      dark: '#180A3B',
    },
    secondary: {
      main: '#f99f24',
      light: '#FAF3E5',
      dark: '#F3911D',
    },
    success: {
      main: '#69C034',
      light: '#E8F9E2',
      dark: '#4CAF50',  
    },
    warning: {
      main: '#FFA800',
    },
    error: {
      main: '#FF0000',
      light: '#fce6e8ff',
      dark: '#D32F2F',
    },
    info: {
      main: '#32b6be',
      light: '#E0F7FA',
      dark: '#0288D1',
    },
    background: {
      default: '#f5f5f5',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 0 20px 0 rgba(76, 87, 125, 0.02)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#3F4254',
          boxShadow: '0 0 20px 0 rgba(76, 87, 125, 0.02)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#080025',
          color: '#FFFFFF',
          width: 280,
        },
      },
    },
  },
}); 